<template>
  <div class="c mb-xxl">
    <div class="rop rop-x">
      <div class="rop-t"><h2 class="h3 fc-2">Komplexné cestovné poistenie GOLD
        <PdfInfoTooltip class="tooltip" v-if="this.product" :link="tooltipLink" placement="top"  />
      </h2>
      </div>

    </div>
<!--    <div class="rop">-->
      <div v-for="(item, key) in productCoverage" :key="key" class="rop">
        <div class="top-t">{{ item.title }}</div>
        <div class="rop-c">
          <div class="rop-b rop-bf">
            <div>{{ item.content }}</div>
          </div>
        </div>
<!--    </div>-->
  </div>
    <div class="rop" v-if="showPrice">
      <div class="rop-t"><h4>Cena</h4></div>
      <div class="rop-c">
        <div class="rop-b rop-bf">
          <strong>{{ price }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdfInfoTooltip from "@/components/PdfInfoTooltip.vue";

export default {
  name: 'InsuranceCoverageTable',
  components: {PdfInfoTooltip},
  props: {
    product: String,
    showPrice: Boolean ,
    price: String,
  },
  data() {
    return {
      insuranceCoverage: {
        medicalExpenses: {
          description: "Liečebné náklady v prípade úrazu / náhleho ochorenia – vrátane covid",
          amount: 300000,
        },
        assistanceAbroad: {
          description: "Asistenčné služby v zahraničí"
        },
        legalAssistance: {
          description: "Právna pomoc",
          amount: 5000,
        },
        longTermInjuryConsequences: {
          description: "Trvalé následky úrazu",
          amount: 10000,
        },
        accidentalDeath: {
          description: "Smrť úrazom",
          amount: 5000,
        },
        liability: {
          description: "Zodpovednosť za škody",
          amount: 100000,
        },
        baggage: {
          description: "Batožina – krádež, strata, poškodenie",
          amount: 500,
        },
        tripCurtailment: {
          description: "Skrátenie cesty – predčasný návrat",
          amount: 600,
        }
      },
      productOverrides: {
        'short_sk_event': {
          includedItems: [
            'longTermInjuryConsequences',
            'accidentalDeath', 'liability', 'baggage'
          ],
        },
        'short_eu_day': {
          includedItems: [
            'medicalExpenses', 'assistanceAbroad', 'legalAssistance',
            'longTermInjuryConsequences',
            'accidentalDeath', 'liability', 'baggage', 'tripCurtailment',
          ]
        },
        'short_eu_world': {
          includedItems: [
            'medicalExpenses',
            'assistanceAbroad',
            'legalAssistance',
            'longTermInjuryConsequences',
            'accidentalDeath',
            'liability',
            ['baggage', 1000],
            'tripCurtailment',
          ]
        }

      }
    };
  },
  methods: {
    formatCurrency(amount, currency) {
      return new Intl.NumberFormat("sk-SK", {
        style: "currency",
        maximumFractionDigits: 0,
        currency
      }).format(amount);
    }
  },
  computed: {
    tooltipLink() {
      return "/attachments/" + this.product + "_sk/rozsah_KCP.pdf";
    },
    productCoverage() {
      let overrides = this.productOverrides[this.product];
      let output = [];
      overrides.includedItems.map(item => {
        let info;
        let price;
        if (typeof item === 'string') {
          info = this.insuranceCoverage[item];
          price = info.amount;
        }else if(typeof item === 'object') {
          info = this.insuranceCoverage[item[0]];
          price = item[1];
        }
        output.push({
            title: info.description,
            content: info.amount ? this.formatCurrency(price, 'EUR') : 'zahrnuté'
        })


      })
      return output;

    }
  }
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}
.tooltip{
  position: relative;
  top: -3px;
  margin-left: 2px;
  font-size: 1.5em;
}
</style>
